import { Link } from "react-router-dom";

const categories = [
  { name: "电影", desc: "影院级激情佳作", icon: "ri-film-line", tone: "primary" },
  { name: "电视剧", desc: "追到停不下来的长剧", icon: "ri-tv-2-line", tone: "accent" },
  { name: "网络剧", desc: "新鲜敢拍的网生内容", icon: "ri-smartphone-line", tone: "secondary" },
  { name: "短片", desc: "短小精悍的氛围之作", icon: "ri-movie-2-line", tone: "primary" },
];

const toneMap: Record<string, string> = {
  primary: "bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50",
  accent: "bg-accent-100 text-accent-800 group-hover:bg-accent-500 group-hover:text-foreground-950",
  secondary: "bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50",
};

export default function CategoryQuick() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {categories.map((cat) => (
        <Link
          key={cat.name}
          to={`/category?type=${encodeURIComponent(cat.name)}`}
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer md:p-5"
        >
          <span
            className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg transition-colors ${toneMap[cat.tone]}`}
          >
            <i className={`${cat.icon} text-2xl`} />
          </span>
          <div className="min-w-0">
            <div className="flex items-center gap-1 text-base font-semibold text-foreground-950">
              {cat.name}
              <i className="ri-arrow-right-line text-sm text-foreground-400 transition-transform group-hover:translate-x-1" />
            </div>
            <div className="mt-1 truncate text-sm text-foreground-500">{cat.desc}</div>
          </div>
        </Link>
      ))}
    </div>
  );
}